import React from 'react'
let PropTypes = React.PropTypes
// NOTIFICACIONES
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
import moment from 'moment'
moment.locale('es')
// API
import api from '../../apiClient/v1'
// COMPONENTES
import { TablaInventarios } from './TablaInventarios.jsx'
import BlackBoxInventarios from './BlackBoxInventarios.js'
// MODALES
import {
    ModalTrigger,
    ModalDetalle,
    ModalDetalleCliente
} from './Modales.jsx'

export class MantenedorDiferencias extends React.Component{
    constructor(props){
        super(props)
        this.blackbox = new BlackBoxInventarios()
        this.state = {
            mes: this.props.meses[0]['value'],
            fechaInicialSeleccionada: moment().startOf('month'),
            fechaFinalSeleccionada: moment().endOf('month'),
            inventariosFiltrados: [],
            filtros: {}
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
        this.buscarInventarios = ()=>{
            let mes = this.state.mes
            api.inventario.getInventariosDif(mes)
                .then(inventarios=>{
                    this.blackbox.reset()
                    inventarios.forEach(inventario=>this.blackbox.add(inventario))
                    this.setState( this.blackbox.getListaFiltrada())
                })
        }
        this.onSelectMesChanged = (evt)=>{
            this.setState({
                mes: evt.target.value
            }, ()=>{
                this.buscarInventarios()
            })
        }
        this.generarFacturaTxt= ()=>{
            let request = api.facturacionSaldo().generarSaldo(this.state.mes)
            request
                .then(()=>this.refs.notificator.success("Proceso satisfactorio", "archivo txt de factura generado y enviado correctamente.", 4*1000)
                )
                .catch(this.ajaxErrorHandler('Generar factura'));
            return request
        }
        this.generarCorreoSEI = (total)=>{
            console.log(total)
            let request = api.facturacion(2).generarCorreoIG(this.state.mes, total)
            request
                .then(()=>this.refs.notificator.success("Proceso satisfactorio", "Se ha notificado su aprobación a SEI", 4*1000)
                )
                .catch(this.ajaxErrorHandler('Aprobacion inventarios'));
            return request
        }
    }
    getChildContext(){
        return {
            aprobacionCliente: (idInventario, aprobacionCliente)=>{
                api.inv(idInventario).actualizarAprobacionFCV(aprobacionCliente)
                    .then(inventarioActualizado=> {
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState(this.blackbox.getListaFiltrada())
                    })        
            },
            aprobacionSei: (idInventario, aprobacionSei)=>{
                api.inv(idInventario).actualizarAprobacionSei(aprobacionSei)
                    .then(inventarioActualizado=> {
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState(this.blackbox.getListaFiltrada())
                    })
            },
            stockCliente: (idInventario, unidadesFCV)=>{
                api.inv(idInventario).actualizarStockFCV(unidadesFCV)
                    .then(inventarioActualizado=>{
                        console.log('inventario actualizado correctamente')
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState( this.blackbox.getListaFiltrada())
                    })
            },
            observacionCliente:(idInventario, observacionCliente)=>{
                api.inv(idInventario).actualizarObservacion(observacionCliente)
                    .then(inventarioActualizado=>{
                        console.log('inventario actualizado correctamente')
                        this.blackbox.actualizarInventario(inventarioActualizado)
                        this.setState( this.blackbox.getListaFiltrada())
                    })
            },
            actualizarFiltro: (nombreFiltro, filtro)=>{
                this.blackbox.reemplazarFiltro(nombreFiltro, filtro)
                this.setState(this.blackbox.getListaFiltrada())
            }
        }
    }
    componentWillMount(){
        this.buscarInventarios()
    }
    render(){
        return (
            <div className={'container-fluid'}>
                <div className={'row'}>
                    <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                    <div className={'col-sm-2 form-group '}>
                        <label className="control-label" htmlFor="selectMes">Mes</label>
                        <select className="form-control"  name="selectMes"
                                ref={ref=>this.inputMes=ref}
                                value={this.state.mes}
                                onChange={this.onSelectMesChanged.bind(this)}>
                            >
                            {this.props.meses.map((mes, index)=>{
                                return <option key={index} value={mes['value']}>{`${mes['text']}`}</option>
                            })}
                        </select>
                    </div>
                    {this.props.permisos.aprobarUndSEI?
                        <BotonFacturar
                            permisos={this.props.permisos}
                            generarFactura={this.generarFacturaTxt}
                            mes={this.state.mes}
                            generarCorreoSEI={this.generarCorreoSEI}
                        />
                        :
                        <BotonDetalles
                            permisos={this.props.permisos}
                            generarFactura={this.generarFacturaTxt}
                            mes={this.state.mes}
                            generarCorreoSEI={this.generarCorreoSEI}
                        />
                    }    
                    <BotonExcel
                        mes={this.state.mes}
                    />
                </div>    
                <TablaInventarios
                    permisos = {this.props.permisos}
                    inventarios ={this.state.inventariosFiltrados}
                    filtros={this.state.filtros}
                />
            </div>
        )
    }
}
MantenedorDiferencias.propTypes = {
    meses: PropTypes.arrayOf(PropTypes.object),
    // Permisos
    permisos: PropTypes.object.isRequired
}
MantenedorDiferencias.childContextTypes = {
    aprobacionCliente: PropTypes.func,
    aprobacionSei: PropTypes.func,
    stockCliente: PropTypes.func,
    observacionCliente: PropTypes.func,
    actualizarFiltro: PropTypes.func
}
const BotonFacturar = ({permisos, generarFactura, mes, generarCorreoSEI})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary pull-right" onClick={showModal}>
                {permisos.aprobarUndCliente?'Detalles': 'Facturar'}
                {isVisible && <ModalDetalle
                    permisos={permisos}
                    mes={mes}
                    hideModal={hideModal}
                    generarFactura={generarFactura}
                    generarCorreoSEI={generarCorreoSEI}
                />}
            </button>
        }
    </ModalTrigger>
const BotonDetalles = ({permisos, generarFactura, mes, generarCorreoSEI})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary pull-right" onClick={showModal}>
                {permisos.aprobarUndCliente?'Detalles': 'Facturar'}
                {isVisible && <ModalDetalleCliente
                    permisos={permisos}
                    mes={mes}
                    hideModal={hideModal}
                    generarFactura={generarFactura}
                    generarCorreoSEI={generarCorreoSEI}
                />}
            </button>
        }
    </ModalTrigger>
const BotonExcel = ({mes})=>
    <a className={'btn btn-md btn-success pull-right'}
       href={`/inventarios/diferencia/descargar-excel-mes?mes=${mes}`}>
       Datos Excel
    </a>


// WEBPACK FOOTER //
// ./frontEnd/inventarios/diferencias-inventarios/MantenedorDiferencias.jsx